var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprites.ac54445d1613340514c60a907f401fb1.svg#c';
                    var viewUrl = 'sprites.ac54445d1613340514c60a907f401fb1.svg#view-c';

                    

                    module.exports = {
                        url: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 48 48',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };